import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../../../components-react/ReactAlert";
import { commonPostPutApi } from "../../../../redux/reducers/commonApiSlice";
import { approve_reject_hygine_task } from "../../../../data/ApiEndpoints";
import Loader from "../../../ui/Loader";
import DetailListings from "./DetailListings";
import {
  checkAllImagesVerified,
  checkAllVideosVerified,
} from "../hygine-task-overview/HygieneMocksData";

export const TaskVerifyWithDetails = ({
  userInfoData,
  rowData,
  callFunction,
  closeModal,
}) => {
  const [verifiedImages, setVerifiedImages] = useState([]);
  const [verifiedVideos, setVerifiedVideos] = useState([]);
  const mediaVerificationRef = useRef(null);

  return (
    <>
      <div ref={mediaVerificationRef}>
        <DetailListings
          row={rowData}
          verifiedImages={verifiedImages}
          setVerifiedImages={setVerifiedImages}
          verifiedVideos={verifiedVideos}
          setVerifiedVideos={setVerifiedVideos}
        />
      </div>

      <TaskVerify
        userInfoData={userInfoData}
        rowData={rowData}
        callFunction={callFunction}
        closeModal={closeModal}
        verifiedImages={verifiedImages}
        verifiedVideos={verifiedVideos}
        mediaVerificationRef={mediaVerificationRef}
      />
    </>
  );
};

const TaskVerify = ({
  userInfoData,
  rowData,
  callFunction,
  verifiedImages = [],
  verifiedVideos = [],
  mediaVerificationRef = null,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading1 } = useSelector((state) => state.common);

  const forminitials = {
    description: "",
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [showRemarks, setShowRemarks] = useState(false);

  const validateForm = (formValues, isReject) => {
    let errors = {};

    if (isReject) {
      if (!formValues.description?.trim()) {
        errors.description = "Remarks are required for rejection!";
      } else if (formValues.description?.trim().length < 30) {
        errors.description = "Remarks must be at least 30 characters!";
      }
    }

    return errors;
  };

  const handleSubmitForm = async (payload) => {
    const method = "POST";
    const endpoint = approve_reject_hygine_task;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setFormValues(forminitials);
        callFunction();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleRejectClick = () => {
    setShowRemarks(true);
    setFormErrors({});
  };

  const onSubmit = (isReject) => {
    const allImagesVerified = checkAllImagesVerified(rowData, verifiedImages);
    const allVideosVerified = checkAllVideosVerified(rowData, verifiedVideos);

    if (!allImagesVerified) {
      toast.error(
        "Please verify all images before approving or rejecting this task!"
      );
      if (mediaVerificationRef?.current) {
        mediaVerificationRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      return;
    }

    if (!allVideosVerified) {
      toast.error(
        "Please verify all videos before approving or rejecting this task!"
      );
      if (mediaVerificationRef?.current) {
        mediaVerificationRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      return;
    }

    if (isReject && !showRemarks) {
      handleRejectClick();
      return;
    }

    const errors = validateForm(formValues, isReject);
    setFormErrors(errors);

    if (Object.keys(errors)?.length === 0) {
      const userData = {
        task_sublog_id: rowData?.uid || "",
        approval_status: isReject ? 2 : 1,
        aprv_rej_remarks: formValues.description || "",
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        isReject
          ? "Are you sure you want to reject this task? Please ensure you have reviewed the task thoroughly and provided detailed remarks explaining the rejection. This action cannot be undone."
          : "Are you sure you want to approve this task? This action cannot be undone.",
        "Cancel",
        `${isReject ? "Reject" : "Approve"}`
      );
    }
  };

  return (
    <form className="formContainer mt30 mb15">
      {/* {showRemarks && ( */}
      <div className="formInputsGrid oneGridSystem">
        <div className="formInputBox span4">
          <label htmlFor="description" className="formInputLabel">
            Approval Remarks{" "}
            {formErrors?.description && <span className="required">*</span>}
          </label>
          <p className="doc-tasks-info">
            Provide detailed remarks explaining your decision to reject this
            task. Include observations about task quality, completion status,
            and any issues found.{" "}
            <span className="doc-tasks-info-highlight">
              Minimum 30 characters required.
            </span>{" "}
            Current: {formValues.description?.length || 0} characters
          </p>

          <textarea
            name="description"
            className={`formInput ${formErrors.description ? "formError" : ""}`}
            style={{
              background: "#fff",
              minHeight: "150px",
            }}
            placeholder="Enter detailed remarks about why you are rejecting this task (minimum 30 characters)..."
            value={formValues.description || ""}
            onChange={(e) =>
              setFormValues((prevs) => ({
                ...prevs,
                description: e.target.value,
              }))
            }
          ></textarea>
          <span className="error-label">{formErrors?.description || ""}</span>
        </div>
      </div>
      {/* )} */}

      <div className="formButtons" style={{ justifyContent: "flex-end" }}>
        {postPutLoading1 ? (
          <Loader />
        ) : (
          <>
            <Button
              className="saveBtn"
              variant="primary"
              onClick={() => onSubmit(false)}
            >
              Approve Task
            </Button>
            <Button
              className="saveBtn"
              variant="danger"
              onClick={() => onSubmit(true)}
            >
              Reject Task
            </Button>
          </>
        )}
      </div>
    </form>
  );
};

export default TaskVerify;
